// extracted by css-extract-rspack-plugin
export default {"capitalize":"GLC12y"};